import DwinityLoader from "../DwinityLoader";
import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import { AppContext } from "../../AppContextProvider";
import { Network, DataSet } from "vis-network/standalone";
import { useTranslation } from "react-i18next";
import { DarkGroups } from "./data/DarkGroups";
import { LightGroups } from "./data/LightGroups";
import InfoView from "../InfoView";
import ContextMenuComponent from "../ContextMenuComponent";
import ContextInfoComponent from "../ContextInfoComponent";
import mini_human_dark from "../../assets/media/images/twin-mini_dark.png";
import mini_human_light from "../../assets/media/images/twin-mini_dark.png";
import twin_half_body from "../../assets/media/images/twin-half-body.png";
import twin_background_mask from "../../assets/media/images/twin-background-mask.svg";
import NetworkMaleModel from "./network/NetworkMaleModel";
import searchicon from "../../assets/media/icons/canvas searchicon.svg";
import { darkColors, lightColors } from "../../data/SampleData";
import moment from "moment";
import { WarningTicket, InformationsTicket, NotificationsTicket, ErrorTicket } from "../TicketsComponent";
import {
  deleteSingle2,
  findChildrenOfNodeById2,
  GROUP_FULL,
  RELATION_FILE_FOLDER2,
  TYPE_FOLDER2,
} from "../../utils/graph/graphmodifier2";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import { unProcessAndSaveProcessedGraphJwt } from "../../utils/graph/graphloader2";
import { loadJwt } from "../../utils/dwclient/localstorage/jwtStorage";
import { MDBTooltip } from "mdb-react-ui-kit";
import InfoComponent from "../InfoComponent";
import CreateFolderNameModal from "../../modals/CreateFolderNameModal";
import { removeFile } from "../../utils/dwclient/dwstorage";
import { readFileCached } from "../../utils/previewCache";
import { MDBCheckbox } from "mdb-react-ui-kit";
import { getMetadataJwt } from "../../utils/dwclient/dwmetadata";
import { getOnlyNumbers } from "../../utils/utils";
import { decryptBlob, encryptAsciiStringToHexString, encryptFile } from "../../utils/dataEncryption";

import {
  concatLogsAndVars,
  createEmptyLogsAndVars,
  dwReportError,
  recordVariable,
  ReportingError,
} from "../../utils/diagnostics/clientErrors";
import MenuComponent from "./MenuComponent";
import CubeCategories from "./CubeCategories";
import { twinModalParams } from "../../data/SampleData";
import { utilSingleFileDownload } from "../../utils/zipdownload/downloadcomponentutil";
import { formatTimeHHMMSS } from "../../utils/paths";

export default function GraphUserComponent2(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);

  const basicRef = useRef(null);
  const containerRef = useRef(null);
  const networkRef = useRef(null);
  const { selectedAccount, selectedWallet } = useContext(WalletProviderContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const [isDark, setIsDark] = useState(true);
  const [nodeDatas, setNodeDatas] = useState({});
  const [isNodeSelect, setIsNodeSelect] = useState(false);
  const [network, setNetwork] = useState(null);
  const [activeTab, setActiveTab] = useState(
    sessionStorage.getItem("activeTab") ? JSON.parse(sessionStorage.getItem("activeTab")) : "everything",
  );
  const [isVisibility, setIsVisibility] = useState(
    localStorage.getItem("isLottieLookingAtIt") && localStorage.getItem("isLottieLookingAtIt") === "true"
      ? false
      : true,
  );
  const [isVisibility2, setIsVisibility2] = useState(true);
  const [isVisibility3, setIsVisibility3] = useState(false);
  const [isTransition, setIsTransition] = useState(false);
  const [isVisibilityDiv, setIsVisibilityDiv] = useState(true);
  const [originalGraph, setOriginalGraph] = useState(props.graphData);
  const [actuelleGraph, setActuelleGraph] = useState();
  
  // Create stable DataSets for network that only update when data changes
  const nodesDataSet = useRef(new DataSet());
  const edgesDataSet = useRef(new DataSet());
  const [timeLineItems, setTimeLineItems] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSendingInProgress, setIsSendingInProgress] = useState(false);
  const [isSentTo, setIsSentTo] = useState(false);
  const [isWarningTicket, setIsWarningTicket] = useState(false);
  const [isErrorTicket, setIsErrorTicket] = useState(false);
  const [isErrorTicketRefreshGraphAfterClose, setIsErrorTicketRefreshGraphAfterClose] = useState(false);
  const [isWarningTicketDelete, setIsWarningTicketDelete] = useState(false);
  const [isDoneTicketDelete, setIsDoneTicketDelete] = useState(false);
  const [selectedNode, setSelectedNode] = useState();
  const [cid, setCid] = useState();
  const [blobFile, setBlobFile] = useState();
  const [file, setFile] = useState();
  const [status, setStatus] = useState("");
  const [isDownloadButton, setIsDownloadButton] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [errortext, setErrortext] = useState("");
  const [selectedPath, setSelectedPath] = useState();
  const [isInfoTickets, setIsInfoTickets] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [isShowFilesChecked, setIsShowFilesChecked] = useState(false);
  const [isMetadataHideChecked, setIsMetadataHideChecked] = useState(false);
  const [isExpandAll, setIsExpandAll] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [category, setCategory] = useState("everything");
  const [nodes, setNodes] = useState([]);
  const [scale, setScale] = useState();
  const [isHideMetafiles, setIsHideMetafiles] = useState(false);
  const [actuellePosition, setActuellePosition] = useState({ x: 0, y: 0 });
  const [standardPosition, setStandardPosition] = useState({ x: 1, y: 1 });
  const [metaData, setMetaData] = useState();
  const [isAddNewBubble, setIsAddNewBubble] = useState(false);
  const [isUserFolder, setIsUserFolder] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [optionParam, setOptionParam] = useState("");
  const [newBubble, setNewBubble] = useState();
  const [isEditMode, setIsEditMode] = useState(sessionStorage.getItem("hideMetaData") !== null ? true : false);
  const [bar, setBar] = useState(document.getElementById("progress-bar"));
  const [size, setSize] = useState(document.getElementById("file-size"));
  const [details, setDetails] = useState(document.getElementById("file-details"));
  const [timer, setTimer] = useState(document.getElementById("file-timer"));
  const [timertext, setTimertext] = useState(document.getElementById("file-timer-text"));
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    scale: null,
    x: 0,
    y: 0,
    menuSize: 100,
    nodeId: null,
    network: null,
    canvasHeight: 0,
  });
  const [contextMenuInfo, setContextMenuInfo] = useState({
    visible: false,
    scale: null,
    x: 0,
    y: 0,
    nodeId: null,
    menuSize: 100,
    network: null,
    canvasHeight: 0,
  });

  const downloadLimit = process.env.DOWNLOAD_LIMIT_FOR_PREVIEW ?? 15728640;

  // Memoize expensive computations
  const amazonDumpInfo = useMemo(() => {
    const amazonDump = originalGraph?.nodes?.find((k) => k.storagePath?.includes("Imported/Amazon"));
    const fileCount = originalGraph?.nodes?.filter((k) => k._type?.includes("meta_layer/node/file")).length || 0;
    if (amazonDump) {
      return {
        isAmazonDump: true,
        text: t('files.upload.lastUpload') + " " + moment(amazonDump.createdAt).locale("de").format("DD.MM.YYYY, HH:mm"),
        fileCount: fileCount,
        date: amazonDump.createdAt,
      };
    }
    return { isAmazonDump: false, text: "Not imported yet" };
  }, [originalGraph]);

  var newFolderIdNumber = { newFolderIdNumber: 0 };

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (context.getState()?.isProgress) {
      setBar(document.getElementById("progress-bar"));
      setSize(document.getElementById("file-size"));
      setDetails(document.getElementById("file-details"));
      setTimer(document.getElementById("file-timer"));
      setTimertext(document.getElementById("file-timer-text"));
    }
  }, [context.getState()?.isProgress]);

  useEffect(() => {
    if (
      props.isGrapView === true &&
      context.getState()?.modalName !== "dataimport" &&
      context.getState()?.modalName !== "fileupload"
    ) {
      if (bar !== null) {
        readFileTest2();
      }
    }
  }, [bar]);

  const handleWindowSizeChange = useCallback(() => {
    setContextMenu({
      visible: false,
      scale: null,
      x: 0,
      y: 0,
      menuSize: 100,
      nodeId: null,
      network: null,
      canvasHeight: 0,
    });
  }, []);

  const handleWindowInfoSizeChange = useCallback(() => {
    setContextMenuInfo({
      visible: false,
      scale: null,
      x: 0,
      y: 0,
      nodeId: null,
      menuSize: 100,
      network: null,
      canvasHeight: 0,
    });
  }, []);

  const bubbleCountInGroup = 20;
  const groupCount = 20;

  function createIncreasingArray(length) {
    const array = [];
    for (let i = 0; i < length; i++) {
      array.push(i + 1);
    }
    return array;
  }

  const groupingOfbubbles2 = (processedGraph, network) => {
    let finallyGroupedArray = [];

    let groupingNodes = processedGraph.nodes.filter(
      (k) => network.getConnectedNodes(k.id, "to").length > bubbleCountInGroup,
    );

    for (let node of groupingNodes) {
      let childrenIdsArray = findChildrenOfNodeById2(processedGraph, node.id).map((k) => k.id);
      const groupedArray = makeMultiLevelGroups(childrenIdsArray, node.id);
      for (let groupObject of groupedArray) {
        if (groupObject.array.length > 0) {
          clusterByNode(groupObject, network);
          finallyGroupedArray.push(groupObject);
        }
      }
    }

    sessionStorage.setItem("finallyGroupedArray", JSON.stringify(finallyGroupedArray));
  };

  function makeMultiLevelGroups(idsArray, parentNodeId) {
    const childrenIdGroupsArray = idsArray.map((id, idx) => {
      return {
        id: id,
        groupId: "groupCluster" + id,
        parentId: parentNodeId,
        label: idx + 1 + "-" + (idx + 1),
        array: [id],
        firstLevel: true,
      };
    });
    let levels = [];
    let level = childrenIdGroupsArray;
    let nextLevel;
    do {
      nextLevel = mergeChildrenIdGroups(level, groupCount);
      levels.push(nextLevel);
      level = nextLevel;
    } while (level.length > bubbleCountInGroup);
    const groupedArray = levels.flat();
    return groupedArray;
  }

  function mergeChildrenIdGroups(source, groupCount) {
    let targetArray = [];
    for (let i = 0; i < source.length; i += groupCount) {
      let current = source[i];
      let target = {
        id: current.id,
        groupId: current.firstLevel ? current.groupId : "super" + current.groupId,
        parentId: current.parentId,
        label: current.label,
        array: current.firstLevel ? [...current.array] : [current.groupId],
      };
      const childrenArray = [];
      for (let j = 1; j < groupCount && i + j < source.length; j++) {
        childrenArray.push(source[i + j]);
      }
      if (childrenArray.length > 0) {
        const lastIndex = childrenArray.length - 1;
        target.label =
          target.label.substring(0, target.label.indexOf("-")) +
          childrenArray[lastIndex].label.substring(childrenArray[lastIndex].label.indexOf("-"));
        for (let childObj of childrenArray) {
          if (childObj.firstLevel) {
            target.array.push(...childObj.array);
          } else {
            target.array.push(childObj.groupId);
          }
        }
      }
      targetArray.push(target);
    }
    return targetArray;
  }

  function chunkMaxLength(arr, chunkSize, maxLength) {
    return Array.from({ length: maxLength }, () => arr.splice(0, chunkSize));
  }

  useEffect(() => {
    sessionStorage.setItem("isAmazonDump", JSON.stringify(amazonDumpInfo));
    if (sessionStorage.getItem("isExpandAll") === null) {
      sessionStorage.setItem("isExpandAll", false);
    }
    setOriginalGraph(props.graphData);
  }, [props.graphData, amazonDumpInfo]);

  useEffect(() => {
    setIsRender(true);
    onSetActuelleGraph();
  }, [context.getState()?.isRender, isDark, originalGraph, isVisibility2]);

  const nodesReduction = useCallback((network, nodes) => {
    if (network) {
      let count = 200;
      let bubleCount = 0;

      let levelSet = new Set(nodes.map((k) => k.level));
      let levelArray = Array.from(levelSet);

      let number = 0;
      while (bubleCount < count || number === levelArray.length - 1) {
        bubleCount = bubleCount + nodes.filter((k) => k.level === levelArray[number]).length;
        number = number + 1;
      }

      if (number < levelArray.length - 1) {
        let nodeIds = nodes.filter((k) => k.level === levelArray[number - 1]).map((k) => k.id);
        for (let nodeId of nodeIds) {
          clusterByCid(nodeId, network);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (network && Math.abs(standardPosition.x - actuellePosition.x) > 1) {
      for (var key in network.getPositions()) {
        if (
          Math.abs(network.getPositions()[key].x - actuellePosition.x) < 500 &&
          Math.abs(network.getPositions()[key].y - actuellePosition.y) < 500 &&
          network.isCluster(key) == true
        ) {
          network.openCluster(key);
          var nodeIsArray2 = network.getConnectedNodes(getOnlyNumbers(key), "to");
          for (let node of nodeIsArray2) {
            clusterByCid(node, network);
          }
        }
      }
      setStandardPosition(actuellePosition);
    }
  }, [actuellePosition]);

  useEffect(() => {
    if (network) {
      network.fit();
    }
  }, [network, props.isGrapView]);

  var locales = {
    en: {
      edit: "Edit",
      del: "Delete Connection",
      back: "Back",
      addNode: "Add folder",
      addEdge: "Add connection",
      editNode: "Edit Folder",
      editEdge: "Edit Edge",
      addDescription: "Click in an empty space to place a new node.",
      edgeDescription: "Click on a node and drag the edge to another node to connect them.",
      editEdgeDescription: "Click on the control points and drag them to a node to connect to it.",
      createEdgeError: "Cannot link edges to a cluster.",
      deleteClusterError: "Clusters cannot be deleted.",
      editClusterError: "Clusters cannot be edited.",
    },
  };

  const setNetworkOption = useCallback((damping, maxVelocity, minVelocity, timestep, gravitationalConstant) => {
    if (network) {
      network.setOptions({
        physics: {
          enabled: true,
          barnesHut: {
            theta: 0.5,
            gravitationalConstant: gravitationalConstant,
            centralGravity: 0.4,
            springLength: 120,
            springConstant: 0.06,
            damping: damping,
            avoidOverlap: 0,
          },

          maxVelocity: maxVelocity,
          minVelocity: minVelocity,
          solver: "barnesHut",
          stabilization: {
            enabled: true,
            iterations: 1000,
            updateInterval: 100,
            onlyDynamicEdges: false,
            fit: true,
          },
          timestep: timestep,
          adaptiveTimestep: true,
        },
      });
    }
  }, [network]);

  function setEditGraphOption(isEditgraph) {
    if (network) {
      network.setOptions({
        physics: {
          enabled: isEditgraph ? false : true,
        },
        manipulation: {
          enabled: isEditgraph ? true : false,
          initiallyActive: true,
          addNode: function (nodeData, callback) {
            nodeData.label = "Now add connection";
            nodeData.group = "92b";
            nodeData._type = "dwin://schema/graph/filesystem_layer/node/folder";
            setNewBubble(nodeData);
            network.body.data.nodes.add(nodeData);
            callback(nodeData);
            setIsAddNewBubble(true);
          },
          addEdge: function (edgeData, callback) {
            let fromNode =
              actuelleGraph.nodes.find((k) => k.id === edgeData.from) !== undefined
                ? actuelleGraph.nodes.find((k) => k.id === edgeData.from)
                : nodes.get(edgeData.from);
            const initialNode = nodes.get(edgeData.to);
            let toNode =
              actuelleGraph.nodes.find((k) => k.id === edgeData.to) !== undefined
                ? actuelleGraph.nodes.find((k) => k.id === edgeData.to)
                : initialNode;
            if (actuelleGraph.nodes.find((k) => k.id === edgeData.from) !== undefined) {
              if (fromNode.uploadAllowed !== true) {
                setErrortext("You cannot initiate a connection from this folder!");
                alert("You cannot initiate a connection from this folder!");
                setIsErrorTicket(true);
              } else {
                if (fromNode._type.includes("/node/file")) {
                  setErrortext("The selected object is a file. Select a folder!");
                  setIsErrorTicket(true);
                } else {
                  if (edgeData.from === initialNode.id) {
                    setErrortext(
                      "It is not possible to initiate a connection from the direction of the new folder. Try it from the other direction!",
                    );
                    setIsErrorTicket(true);
                  } else {
                    if (
                      actuelleGraph.edges.find(
                        (k) =>
                          (k.from === edgeData.from && k.to === edgeData.to) ||
                          (k.to === edgeData.from && k.from === edgeData.to),
                      )
                    ) {
                      setErrortext("This connection edge already exists");
                      setIsErrorTicket(true);
                    } else {
                      if (edgeData.from === edgeData.to) {
                        setErrortext("You cannot bind the node to yourself");
                        setIsErrorTicket(true);
                      } else {
                        if (edgeData.to === initialNode.id) {
                          callback(edgeData);
                          let fromNode = actuelleGraph.nodes.find((k) => k.id === edgeData.from);
                          let fromId = fromNode.id;

                          let idsArray = actuelleGraph.nodes.map((k) => k.id);
                          let lastId = idsArray[idsArray.length - 1];
                          let number = lastId + 1;
                          toNode.id = number;
                          edgeData.to = number;
                          edgeData.from = fromId;
                          edgeData.p = "dwin://schema/graph/filesystem_layer/edge/contains";
                          toNode.group = fromNode.group.charAt(0) + (parseInt(fromNode.group.charAt(1)) + 1) * "b";
                          toNode.cid = fromNode.cid;
                          toNode.level = fromNode.level + 1;

                          delete toNode.x;
                          delete toNode.y;
                          actuelleGraph.edges.push(edgeData);
                          setIsRender(false);
                          setIsAddNewBubble(false);
                          context.openModal("createfolder", edgeData.from, {
                            processedGraph: props.processedGraph,
                            onFinish: () => {
                              context.closeModal();
                              setIsInfoTickets(false);
                              setInfoText("");
                              sessionStorage.removeItem("addNewBuble");
                              sessionStorage.removeItem("isEditGraph");
                              onSetActuelleGraph();
                              setIsAddNewBubble(false);
                              setTimeout(() => {
                                props.refreshGraph();
                              }, 1500);
                            },
                            onError: () => {
                              setErrortext("Folder create has failed!");
                              setIsErrorTicket(true);
                              setIsErrorTicketRefreshGraphAfterClose(true);
                              context.closeModal();
                              setIsInfoTickets(false);
                              setInfoText("");
                              sessionStorage.removeItem("addNewBuble");
                              sessionStorage.removeItem("isEditGraph");
                              onSetActuelleGraph();
                              setIsAddNewBubble(false);
                            },
                            onHide: () => {
                              context.closeModal();
                              setIsVisibility3(true);
                              setIsAddNewBubble(false);
                              setIsInfoTickets(false);
                              setInfoText("");
                              setTimeout(() => {
                                onSetActuelleGraph();
                              }, 200);
                              network.fit();
                              setTimeout(() => {
                                setIsVisibility3(false);
                              }, 500);
                            },
                          });
                        } else {
                          setErrortext("Create the link to the new folder!");
                          setIsErrorTicket(true);
                        }
                      }
                    }
                  }
                }
              }
            } else {
              setErrortext(
                "It is not possible to initiate a connection from the direction of the new folder. Try it from the other direction!",
              );
              setIsErrorTicket(true);
            }
          },
        },
      });
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.7 });
      }, 5);
    }
  }

  const handleSearchChange = useCallback((event) => {
    setSearchTerm(event.target.value);
    if (event.target.value !== "") {
      let searchArray = actuelleGraph.nodes
        .filter((k) => k.label.toLowerCase().includes(event.target.value.toLowerCase()))
        .map((k) => k.id);
      setNetworkOption(0.45, 40, 25, 0.4, -2000);
      clusterBySearch(searchArray);
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.3 });
      }, 1);
    } else {
      setNetworkOption(0.15, 40, 25, 0.4, -2000);
      if (network.isCluster("cidClusterSearch") == true) {
        network.openCluster("cidClusterSearch");
      }
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.1 });
      }, 1);
    }
  }, [actuelleGraph, network]);

  const clearSearch = useCallback(() => {
    setSearchTerm("");
    setNetworkOption(0.15, 40, 25, 0.4, -2000);
    if (network.isCluster("cidClusterSearch") == true) {
      network.openCluster("cidClusterSearch");
    }
    setTimeout(() => {
      network.fit();
      network.moveTo({ scale: 0.1 });
    }, 1);
  }, [network]);

  const setBubbleFilter = (cid, category) => {
    setShowFilesFalse();
    handleWindowSizeChange();
    sessionStorage.removeItem("hideMetaData");
    sessionStorage.removeItem("addNewBuble");
    sessionStorage.removeItem("isEditGraph");
    setIsAddNewBubble(false);
    setEditGraphOption(false);
    if (category !== "everything" && originalGraph.nodes.find((k) => k.cid === cid) !== undefined) {
      setNetworkOption(0.2, 40, 30, 0.6, -2500);

      if (network.isCluster("cidClusterUser") == true) {
        network.openCluster("cidClusterUser");
      }
      sessionStorage.setItem("bubleFilter", JSON.stringify(originalGraph.nodes.find((k) => k.cid === cid).cid));
      clusterByFilter(network);
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.1 });
      }, 50);
    } else {
      setNetworkOption(0.2, 40, 30, 0.6, -2500);
      sessionStorage.removeItem("bubleFilter");
      let array = [];
      if (network.isCluster("cidClusterUser") == true) {
        array = network.getNodesInCluster("cidClusterUser");
        network.openCluster("cidClusterUser");
      }
      if (
        sessionStorage.getItem("isExpandAll") !== null &&
        JSON.parse(sessionStorage.getItem("isExpandAll")) === false
      ) {
        nodesReduction(network, actuelleGraph.nodes);
      }
      for (let nodeId of array) {
        if (network.isCluster(nodeId) == true && !nodeId.toString().includes("groupCluster")) {
          var node = network.body.nodes[nodeId];
          node.setOptions({
            shape: "diamond",
          });
        }
      }

      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.05 });
      }, 10);
    }
    setSelectedNode();
    setIsNodeSelect(false);
    setNodeDatas();
    setActiveTab(category);
    setCategory(category);
    sessionStorage.setItem("activeTab", JSON.stringify(category));
  };

  const setShowFilesTrue = useCallback(() => {
    setIsShowFilesChecked(true);
    let userFilesNode = actuelleGraph.nodes.find((k) => k.label === "User Files");
    sessionStorage.setItem("dataOwnerFilter", JSON.stringify(userFilesNode.cid));
    if (network.isCluster("cidCluster" + userFilesNode.id) == true) {
      network.openCluster("cidCluster" + userFilesNode.id);
    }
    if (sessionStorage.getItem("bubleFilter") !== null) {
      if (network.isCluster("cidClusterUser") == true) {
        network.openCluster("cidClusterUser");
      }
      clusterByFilter(network);
    }

    setInfoText("");
    setSelectedNode();
    setIsNodeSelect(false);
    setNodeDatas();
  }, [actuelleGraph, network]);

  const setShowFilesFalse = useCallback(() => {
    setIsShowFilesChecked(false);
    setHideMetaDataFalse();
    sessionStorage.removeItem("dataOwnerFilter");
    let userFilesNode = actuelleGraph.nodes.find((k) => k.label === "User Files");

    if (userFilesNode) {
      clusterByCid(userFilesNode.id, network, true);
    }
    setInfoText("");
    setSelectedNode();
    setIsNodeSelect(false);
    setNodeDatas();
  }, [actuelleGraph, network, setHideMetaDataFalse]);

  const setHideMetaDataTrue = () => {
    setIsMetadataHideChecked(true);
    clusterByHideMeta(network);
    setInfoText("");
    setSelectedNode();
    setIsNodeSelect(false);
    setNodeDatas();
    setTimeout(() => {
      network.fit();
      network.moveTo({ scale: 0.3 });
    }, 20);
  };

  function setHideMetaDataFalse() {
    setIsMetadataHideChecked(false);

    if (sessionStorage.getItem("bubleFilter") !== null) {
      setNetworkOption(0.2, 40, 30, 0.6, -2500);
      if (network.isCluster("cidClusterUser") == true) {
        network.openCluster("cidClusterUser");
      }
      clusterByFilter(network);
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.15 });
      }, 20);
    } else {
      setNetworkOption(0.2, 40, 30, 0.6, -2500);
      if (network.isCluster("cidClusterUser") == true) {
        network.openCluster("cidClusterUser");
      }
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.08 });
      }, 20);
    }
    setSelectedNode();
    setIsNodeSelect(false);
    setNodeDatas();
  }

  const setBubleChildrenVisibilityHidden = (nodeId) => {
    let clusteredBublesString = sessionStorage.getItem("clusteredNodes");
    let finallyGroupedArray = JSON.parse(sessionStorage.getItem("finallyGroupedArray")).filter(
      (k) => k.parentId === nodeId,
    );
    if (finallyGroupedArray.length > 0) {
      for (let groupObject of finallyGroupedArray) {
        clusterByNode(groupObject, network);
      }
    }
    let clusteredBublesSet;
    if (clusteredBublesString !== null) {
      clusteredBublesSet = new Set(JSON.parse(clusteredBublesString));
    } else {
      clusteredBublesSet = new Set();
    }
    handleWindowSizeChange();
    clusteredBublesSet.add(getOnlyNumbers(nodeId));
    clusterByCid(nodeId, network);
    var array = Array.from(clusteredBublesSet);
    sessionStorage.setItem("clusteredNodes", JSON.stringify(array));
  };

  const setBubleChildrenVisibilityTrue = (nodeId, value) => {
    let clusteredBublesString = sessionStorage.getItem("clusteredNodes");
    let clusteredBublesSet;
    if (clusteredBublesString !== null) {
      clusteredBublesSet = new Set(JSON.parse(clusteredBublesString));
    } else {
      clusteredBublesSet = new Set();
    }
    if (getOnlyNumbers(nodeId) !== nodeId && !value) {
      setNetworkOption(0.5, 60, 45, 0.3, -2500);
      if (network.isCluster(nodeId) == true) {
        network.openCluster(nodeId);
        clusteredBublesSet.delete(getOnlyNumbers(nodeId));
        var nodeIsArray = network.getConnectedNodes(parseInt(getOnlyNumbers(nodeId)), "to");
        for (let node of nodeIsArray) {
          let initialNode = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(nodeId));
          let childrenIdsArray = network
            .getConnectedNodes(getOnlyNumbers(nodeId), "to")
            .filter((k) => k !== "cidClusterUser");

          let nodesArray = originalGraph.nodes
            .filter((k) => childrenIdsArray.includes(k.id))
            .filter((k) => k.cid === initialNode.cid);

          if (nodesArray.length > 0) {
            clusterByCid(getOnlyNumbers(node), network);
            clusteredBublesSet.add(getOnlyNumbers(node));
          }
        }
      }
    }

    if (getOnlyNumbers(nodeId) !== nodeId && value) {
      if (network.isCluster(nodeId) == true) {
        network.openCluster(nodeId);
        clusteredBublesSet.delete(getOnlyNumbers(nodeId));
      }
    }
    var array = Array.from(clusteredBublesSet);
    sessionStorage.setItem("clusteredNodes", JSON.stringify(array));
  };

  const onSetActuelleGraph = useCallback(() => {
    // Work directly with originalGraph data without deep cloning
    const nodesArray = originalGraph.nodes || [];

    const nodesIds = nodesArray.map((k) => k.id);
    const edgesArray = (originalGraph.edges || []).filter((k) => nodesIds.includes(k.from) || nodesIds.includes(k.to));
    
    setActuelleGraph({
      nodes: nodesArray,
      edges: edgesArray,
    });
    
    // Update existing DataSets instead of creating new ones
    if (nodesDataSet.current && edgesDataSet.current) {
      nodesDataSet.current.clear();
      nodesDataSet.current.add(nodesArray);
      edgesDataSet.current.clear();
      edgesDataSet.current.add(edgesArray);
    } else {
      nodesDataSet.current = new DataSet(nodesArray);
      edgesDataSet.current = new DataSet(edgesArray);
    }
    
    const nodes = nodesDataSet.current;
    const edges = edgesDataSet.current;
    setNodes(nodes);
    const data = { nodes, edges };
    const options = {
      autoResize: true,
      clickToUse: false,
      locale: "en",
      locales: locales,
      layout: {
        improvedLayout: false,
        clusterThreshold: 200,
      },
      groups: !isDark ? LightGroups : DarkGroups,
      nodes: { font: { vadjust: 5 }, scaling: { label: { enabled: true } } },
      edges: {
        arrows: {
          to: {
            enabled: false,
            scaleFactor: 0.3,
          },
          from: {
            enabled: false,
            scaleFactor: 0,
          },
        },
        color: {
          color: !isDark ? "#C0C4D9" : "#777FAC",
          hover: !isDark ? "#171926" : "#FFF",
          highlight: !isDark ? "#171926" : "#FFF",
          inherit: "from",
          opacity: 1,
        },
        smooth: {
          enabled: false,
          type: "continuous",
        },
        width: 0.5,
        selectionWidth: 3,
        hoverWidth: 1,
        length: 250,
        physics: true,
        font: {
          color: "#151828",
          size: 18,
          face: "arial",
          background: "#ffffff",
          strokeWidth: 0,
          align: "horizontal",
          multi: false,
          vadjust: 0,
        },
      },
      interaction: {
        navigationButtons: true,
        multiselect: true,
        hover: true,
        hoverConnectedEdges: true,
        keyboard: {
          enabled: false,
          speed: { x: 10, y: 10, zoom: 0.02 },
          bindToWindow: true,
        },
        tooltipDelay: 10,
        zoomSpeed: 1,
      },

      physics: {
        enabled: true,
        barnesHut: {
          theta: 0.5,
          gravitationalConstant: -2500,
          centralGravity: 0.4,
          springLength: 120,
          springConstant: 0.06,
          damping: 0.1,
          avoidOverlap: 0,
        },

        maxVelocity: 40,
        minVelocity: 20,
        solver: "barnesHut",
        stabilization: {
          enabled: true,
          iterations: 1000,
          updateInterval: 100,
          onlyDynamicEdges: false,
          fit: true,
        },
        timestep: 0.6,
        adaptiveTimestep: true,
      },

      width: "100%",
      height: "100%",

      manipulation: {
        enabled: sessionStorage.getItem("hideMetaData") !== null && !isEditMode ? true : false,
        initiallyActive: true,
        addNode: function (nodeData, callback) {
          nodeData.label = "Now add connection";
          nodeData.group = "92b";
          nodeData._type = "dwin://schema/graph/filesystem_layer/node/folder";
          setNewBubble(nodeData);
          callback(nodeData);
          setIsAddNewBubble(true);
        },
        addEdge: function (edgeData, callback) {
          let fromNode =
            actuelleGraph.nodes.find((k) => k.id === edgeData.from) !== undefined
              ? actuelleGraph.nodes.find((k) => k.id === edgeData.from)
              : nodes.get(edgeData.from);
          const initialNode = nodes.get(edgeData.to);
          let toNode =
            actuelleGraph.nodes.find((k) => k.id === edgeData.to) !== undefined
              ? actuelleGraph.nodes.find((k) => k.id === edgeData.to)
              : initialNode;
          if (actuelleGraph.nodes.find((k) => k.id === edgeData.from) !== undefined) {
            if (fromNode.uploadAllowed !== true) {
              setErrortext("You cannot initiate a connection from this folder!");
              setIsErrorTicket(true);
            } else {
              if (fromNode._type.includes("/node/file")) {
                setErrortext("The selected object is a file. Select a folder!");
                setIsErrorTicket(true);
              } else {
                if (edgeData.from === initialNode.id) {
                  setErrortext(
                    "It is not possible to initiate a connection from the direction of the new folder. Try it from the other direction!",
                  );
                  setIsErrorTicket(true);
                } else {
                  if (
                    actuelleGraph.edges.find(
                      (k) =>
                        (k.from === edgeData.from && k.to === edgeData.to) ||
                        (k.to === edgeData.from && k.from === edgeData.to),
                    )
                  ) {
                    setErrortext("This connection edge already exists");
                    setIsErrorTicket(true);
                  } else {
                    if (edgeData.from === edgeData.to) {
                      setErrortext("You cannot bind the node to yourself");
                      setIsErrorTicket(true);
                    } else {
                      if (edgeData.to === initialNode.id) {
                        callback(edgeData);
                        let fromNode = actuelleGraph.nodes.find((k) => k.id === edgeData.from);
                        let fromId = fromNode.id;

                        let idsArray = actuelleGraph.nodes.map((k) => k.id);
                        let lastId = idsArray[idsArray.length - 1];
                        let number = lastId + 1;
                        toNode.id = number;
                        edgeData.to = number;
                        edgeData.from = fromId;
                        edgeData.p = "dwin://schema/graph/filesystem_layer/edge/contains";
                        toNode.group = fromNode.group.charAt(0) + (parseInt(fromNode.group.charAt(1)) + 1) * "b";
                        toNode.cid = fromNode.cid;
                        toNode.level = fromNode.level + 1;

                        delete toNode.x;
                        delete toNode.y;
                        actuelleGraph.edges.push(edgeData);
                        setIsRender(false);
                        setIsAddNewBubble(false);
                        context.openModal("createfolder", edgeData.from, {
                          processedGraph: props.processedGraph,
                          onFinish: () => {
                            context.closeModal();
                            setIsInfoTickets(false);
                            setInfoText("");
                            sessionStorage.removeItem("addNewBuble");
                            sessionStorage.removeItem("isEditGraph");
                            onSetActuelleGraph();
                            setIsAddNewBubble(false);
                            setTimeout(() => {
                              props.refreshGraph();
                            }, 1500);
                          },
                          onError: () => {
                            setErrortext("Folder create has failed!");
                            setIsErrorTicket(true);
                            setIsErrorTicketRefreshGraphAfterClose(true);
                            context.closeModal();
                            setIsInfoTickets(false);
                            setInfoText("");
                            sessionStorage.removeItem("addNewBuble");
                            sessionStorage.removeItem("isEditGraph");
                            onSetActuelleGraph();
                            setIsAddNewBubble(false);
                          },
                          onHide: () => {
                            context.closeModal();
                            setIsVisibility3(true);
                            setIsAddNewBubble(false);
                            setIsInfoTickets(false);
                            setInfoText("");
                            setTimeout(() => {
                              onSetActuelleGraph();
                            }, 200);
                            network.fit();
                            setTimeout(() => {
                              setIsVisibility3(false);
                            }, 500);
                          },
                        });
                      } else {
                        setErrortext("Create the link to the new folder!");
                        setIsErrorTicket(true);
                      }
                    }
                  }
                }
              }
            }
          } else {
            setErrortext(
              "It is not possible to initiate a connection from the direction of the new folder. Try it from the other direction!",
            );
            setIsErrorTicket(true);
          }
        },
        editNode: function (nodeData, callback) {
          callback(nodeData);
        },
        editEdge: false,
        deleteNode: false,
        deleteEdge: false,
      },
    };

    if (containerRef.current && !networkRef.current) {
      // Only create network once
      const canvas = document.getElementById("myCanvas");
      canvas.oncontextmenu = () => false;
      const network = new Network(containerRef.current, data, options);
      setNetwork(network);
      networkRef.current = network;
      groupingOfbubbles2(originalGraph, network);

      // Draw glow effect behind demo users
      network.on("beforeDrawing", (ctx) => {
        const demoUserNodes = originalGraph.nodes.filter(n => n._type === "demo-user");
        demoUserNodes.forEach(node => {
          const nodePosition = network.getPositions([node.id])[node.id];
          if (nodePosition) {
            const glowColor = node.glowColor || "#e91e8c";
            const glowSize = 350;
            
            // Create radial gradient for glow effect
            const gradient = ctx.createRadialGradient(
              nodePosition.x, nodePosition.y, 0,
              nodePosition.x, nodePosition.y, glowSize
            );
            gradient.addColorStop(0, glowColor + "99"); // 60% opacity at center
            gradient.addColorStop(0.4, glowColor + "66"); // 40% opacity
            gradient.addColorStop(0.7, glowColor + "33"); // 20% opacity
            gradient.addColorStop(1, glowColor + "00"); // 0% opacity at edge
            
            ctx.beginPath();
            ctx.arc(nodePosition.x, nodePosition.y, glowSize, 0, 2 * Math.PI);
            ctx.fillStyle = gradient;
            ctx.fill();
          }
        });
      });

      // Network events - JAVÍTOTT RÉSZ
      var doubleClickTime = 0;
      var threshold = 200;

      network.on("selectNode", (params) => {
        var t0 = new Date();
        if (t0 - doubleClickTime > threshold) {
          setTimeout(function () {
            if (t0 - doubleClickTime > threshold) {
              if (
                sessionStorage.getItem("isEditGraph") === null &&
                params.nodes[0] === getOnlyNumbers(params.nodes[0])
              ) {
                setBlobFile();
                const selectedNode = params.nodes[0];
                if (selectedNode) {
                  const initialNode = originalGraph.nodes.find((k) => k.id === selectedNode);

                  setSelectedNode(initialNode);
                  var selectedNodeId = params.nodes[0];
                  var node = network.body.nodes[selectedNodeId];

                  let bubbleSize;
                  if (initialNode.group !== "file") {
                    const actuelleGroup = initialNode.group;
                    bubbleSize = DarkGroups[actuelleGroup].widthConstraint;
                  } else {
                    bubbleSize = 40;
                  }

                  const actuelleNode = initialNode;
                  const position = network.getPosition(selectedNode);
                  const canvasPosition = network.canvasToDOM(position);
                  const scale = network.getScale();
                  const canvasHeight = document.getElementById("myCanvas")?.offsetHeight;
                  const menuSize = bubbleSize;

                  setContextMenuInfo({
                    visible: true,
                    scale: scale,
                    x: canvasPosition.x,
                    y: canvasPosition.y,
                    menuSize: menuSize,
                    nodeId: selectedNode,
                    network: network,
                    canvasHeight: canvasHeight,
                  });

                  if (
                    initialNode.metadataType === undefined &&
                    initialNode._type.split("/")[initialNode._type.split("/").length - 1] === "file"
                  ) {
                    setFileName(initialNode.properties?.fileName);
                    setFileType(initialNode.properties?.fileMimeType);
                    if (
                      initialNode.properties?.fileStorageId !== "" &&
                      initialNode.properties?.fileSize < downloadLimit
                    ) {
                      readFileTest(initialNode);
                    }
                  } else {
                    setFileName();
                    setFileType();
                    setFile();
                  }

                  setIsNodeSelect(true);
                }
              }
              if (network.isCluster(params.nodes[0]) && !params.nodes[0].includes("cidCluster")) {
                const initialNode2 = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(params.nodes[0]));
                let actuelleColor2;
                if (darkColors.filter((k) => k.group === initialNode2.cid + "" + 1 + GROUP_FULL)[0] !== undefined) {
                  actuelleColor2 = darkColors.filter((k) => k.group === initialNode2.cid + "" + 1 + GROUP_FULL)[0]
                    .color;
                } else {
                  actuelleColor2 = "ffffff";
                }
                network.clustering.updateClusteredNode(params.nodes[0], {
                  font: {
                    color: actuelleColor2,
                  },
                });
              }
            }
          }, threshold);
        }
      });

      network.on("deselectNode", (params) => {
        if (sessionStorage.getItem("isEditGraph") === null) {
          setIsNodeSelect(false);
          setFileName();
          setFileType();
          setFile();
          setBlobFile();
          setSelectedNode();
          handleWindowInfoSizeChange();
          setMetaData();
          var deselectedNodeId = params.previousSelection.nodes[0].id;
          const initialNode = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(deselectedNodeId));
          var node = network.body.nodes[getOnlyNumbers(deselectedNodeId)];

          if (
            network.isCluster(params.previousSelection.nodes[0].id) &&
            !params.previousSelection.nodes[0].id.includes("cidCluster")
          ) {
            const initialNode2 = originalGraph.nodes.find(
              (k) => k.id === getOnlyNumbers(params.previousSelection.nodes[0].id),
            );
            let actuelleColor2;
            if (
              darkColors.filter((k) => k.group === initialNode2.cid + "" + initialNode2.level + GROUP_FULL)[0] !==
              undefined
            ) {
              actuelleColor2 = darkColors.filter(
                (k) => k.group === initialNode2.cid + "" + initialNode2.level + GROUP_FULL,
              )[0].color;
            } else {
              actuelleColor2 = "ffffff";
            }
            network.clustering.updateClusteredNode(params.previousSelection.nodes[0].id, {
              font: {
                color: actuelleColor2,
              },
            });
          }
        }
      });

      network.on("click", (params) => {
        handleWindowSizeChange();
        
        if (props.isNetworkViewMode && params.nodes.length === 1) {
          const nodeId = params.nodes[0];
          const node = nodesDataSet.current.get(nodeId);
          
          if (node && node._type === "demo-user" && props.onDemoUserClick) {
            props.onDemoUserClick(nodeId);
          } else if (node && (node.cid === 0 || node.group === "00a") && props.onCentralUserClick) {
            props.onCentralUserClick();
          }
        }
      });
      
      network.on("hoverNode", (params) => {
        if (props.isNetworkViewMode && props.onDemoUserHover) {
          const nodeId = params.node;
          const node = nodesDataSet.current.get(nodeId);
          
          if (node && node._type === "demo-user") {
            const canvasPos = network.getPositions([nodeId])[nodeId];
            const domPos = network.canvasToDOM(canvasPos);
            const containerRect = containerRef.current?.getBoundingClientRect() || { left: 0, top: 0 };
            const screenPos = {
              x: containerRect.left + domPos.x + 40,
              y: containerRect.top + domPos.y - 80
            };
            props.onDemoUserHover(nodeId, screenPos);
          }
        }
      });
      
      network.on("blurNode", () => {
        if (props.isNetworkViewMode && props.onDemoUserHover) {
          props.onDemoUserHover(null, { x: 0, y: 0 });
        }
      });

      network.on("doubleClick", (params) => {
        doubleClickTime = new Date();
        let clusteredBublesString = sessionStorage.getItem("clusteredNodes");
        let clusteredBublesSet;
        if (clusteredBublesString !== null) {
          clusteredBublesSet = new Set(JSON.parse(clusteredBublesString));
        } else {
          clusteredBublesSet = new Set();
        }
        const selectedNodeId = params.nodes[0];
        if (params.nodes.length == 1 && getOnlyNumbers(params.nodes[0]) !== params.nodes[0]) {
          setNetworkOption(0.5, 60, 45, 0.4, -2500);
          if (network.isCluster(params.nodes[0]) == true) {
            network.openCluster(params.nodes[0]);
            clusteredBublesSet.delete(getOnlyNumbers(params.nodes[0]));
            var nodeIsArray = network.getConnectedNodes(getOnlyNumbers(selectedNodeId), "to");
            for (let node of nodeIsArray) {
              let initialNode = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(selectedNodeId));
              let childrenIdsArray = network
                .getConnectedNodes(getOnlyNumbers(node), "to")
                .filter((k) => k !== "cidClusterUser");

              let nodesArray = originalGraph.nodes
                .filter((k) => childrenIdsArray.includes(k.id))
                .filter((k) => k.cid === initialNode.cid);

              if (nodesArray.length > 0) {
                clusterByCid(getOnlyNumbers(node), network);
                clusteredBublesSet.add(getOnlyNumbers(node));
              }
            }
          }
        } else {
          let finallyGroupedArray = JSON.parse(sessionStorage.getItem("finallyGroupedArray")).filter(
            (k) => k.parentId === selectedNodeId,
          );
          if (finallyGroupedArray.length > 0) {
            for (let groupObject of finallyGroupedArray) {
              clusterByNode(groupObject, network);
            }
          }
          clusteredBublesSet.add(getOnlyNumbers(selectedNodeId));
          clusterByCid(selectedNodeId, network);
        }
        var array = Array.from(clusteredBublesSet);
        sessionStorage.setItem("clusteredNodes", JSON.stringify(array));
        handleWindowInfoSizeChange();
        setMetaData();
      });

      network.on("oncontext", (params) => {
        if (sessionStorage.getItem("isEditGraph") === null) {
          handleWindowInfoSizeChange();
          setBlobFile();
          setMetaData();
          params.event.preventDefault();
          const clickedNodeId = network.getNodeAt(params.pointer.DOM);
          const selectedNode = network.getNodeAt(params.pointer.DOM);
          let nodeId = getOnlyNumbers(clickedNodeId);
          if (clickedNodeId && clickedNodeId !== "new-order") {
            handleWindowSizeChange();

            var initialNode = originalGraph.nodes.find((k) => k.id === nodeId);
            setSelectedNode(initialNode);
            if (initialNode !== undefined) {
              if (sessionStorage.getItem("isEditGraph") === null && clickedNodeId === getOnlyNumbers(clickedNodeId)) {
                let fileTypeParts = initialNode._type.split("/");
                let fileTypeLastPart = fileTypeParts[fileTypeParts.length - 1];
                var node = network.body.nodes[clickedNodeId];
              }
            }
            var position = network.getViewPosition();

            network.setSelection({ nodes: [selectedNode] });
            if (clickedNodeId) {
              const actuelleNode = initialNode;
              const actuelleGroup = actuelleNode.group;
              const position = network.getPosition(clickedNodeId);
              const canvasPosition = network.canvasToDOM(position);
              const scale = network.getScale();
              const canvasHeight = document.getElementById("myCanvas")?.offsetHeight;
              let bubbleSize;
              if (initialNode.group !== "file") {
                const actuelleGroup = initialNode.group;
                bubbleSize = DarkGroups[actuelleGroup].widthConstraint;
              } else {
                bubbleSize = 40;
              }
              const menuSize = bubbleSize;

              setContextMenu({
                visible: true,
                scale: scale,
                x: canvasPosition.x,
                y: canvasPosition.y,
                menuSize: menuSize,
                nodeId: clickedNodeId,
                network: network,
                canvasHeight: canvasHeight,
              });
            }
          }
        } else {
          handleWindowSizeChange();
        }
      });

      network.on("zoom", (params) => {
        handleWindowSizeChange();
        handleWindowInfoSizeChange();
        setMetaData();
        if (params.direction === "+") {
          //setActuellePosition(network.DOMtoCanvas(params.pointer));
        }
      });
      network.on("dragStart", (params) => {
        network.canvas.body.container.style.cursor = "grab";
        handleWindowSizeChange();
        handleWindowInfoSizeChange();
        setMetaData();
      });
      network.on("dragEnd", (params) => {
        network.canvas.body.container.style.cursor = "unset";
      });
      // onSetActuelleGraph folytatása - clustering setup
      if (sessionStorage.getItem("bubleFilter") !== null) {
        if (network.isCluster("cidClusterUser") == true) {
          network.openCluster("cidClusterUser");
        }
        clusterByFilter(network);
      }
      if (sessionStorage.getItem("dataOwnerFilter") === null) {
        let userFilesNode = nodesArray.find((k) => k.label === "User Files");
        if (userFilesNode) {
          clusterByCid(userFilesNode.id, network, true);
        }
      }
      if (sessionStorage.getItem("hideMetaData") !== null) {
        clusterByHideMeta(network);
      }
      nodesReduction(network, nodesArray);
      if (sessionStorage.getItem("clusteredNodes") !== null) {
        for (let node of JSON.parse(sessionStorage.getItem("clusteredNodes"))) {
          clusterByCid(node, network);
        }
      }
      setIsAddNewBubble(false);
    } else if (networkRef.current && containerRef.current) {
      // Update existing network instead of recreating
      networkRef.current.setOptions(options);
      networkRef.current.setData(data);
    }
  }, [originalGraph, isDark, isEditMode]);

  const setExpandAllGraph = (isExpand) => {
    if (!isExpand) {
      if (
        sessionStorage.getItem("activeTab") === null ||
        JSON.parse(sessionStorage.getItem("activeTab")) === "everything"
      ) {
        setNetworkOption(0.45, 50, 45, 0.9, -2500);
      } else {
        setNetworkOption(0.2, 40, 30, 0.6, -2500);
      }
      sessionStorage.removeItem("clusteredNodes");
      sessionStorage.setItem("isExpandAll", true);
      let clusteredNodes = actuelleGraph.nodes.filter((k) => k.cid >= 1).map((k) => k.id);
      for (let nodeId of clusteredNodes) {
        if (network.isCluster("cidCluster" + nodeId) == true) {
          network.openCluster("cidCluster" + nodeId);
        }
      }
      groupingOfbubbles2(originalGraph, network);
      if (sessionStorage.getItem("dataOwnerFilter") === null) {
        let userFilesNode = actuelleGraph.nodes.find((k) => k.label === "User Files");
        if (userFilesNode) {
          clusterByCid(userFilesNode.id, network, true);
        }
      }
      if (sessionStorage.getItem("addNewBuble") === null) {
        setTimeout(() => {
          network.fit();
          network.moveTo({ scale: 0.05 });
        }, 20);
      }
    } else {
      setNetworkOption(0.12, 30, 15, 0.6, -300);
      sessionStorage.setItem("isExpandAll", false);
      let childrenNodesArrayIds = originalGraph.nodes.filter((k) => k.level === 1).map((k) => k.id);
      let finallyGroupedArray = JSON.parse(sessionStorage.getItem("finallyGroupedArray"));
      if (finallyGroupedArray.length > 0) {
        for (let groupObject of finallyGroupedArray) {
          clusterByNode(groupObject, network);
        }
      }
      for (let nodeId of childrenNodesArrayIds) {
        clusterByCid(nodeId, network);
      }
      setTimeout(() => {
        network.fit();
        network.moveTo({ scale: 0.2 });
      }, 20);
    }
  };

  const onBubleChildren = (initialNodeId) => {
    let initialNodeCid = originalGraph.idToCidMap[initialNodeId];
    var done = [];
    var todo = [initialNodeId];
    var childrenBublesWithParent = [];

    while (todo.length > 0) {
      let processingId = todo[0];
      todo.splice(0, 1);

      let childrenIds = findChildrenOfNodeById2(props.processedGraph, processingId).map((k) => k.id);

      for (let childId of childrenIds) {
        let childCid = originalGraph.idToCidMap[childId];
        if (childCid === initialNodeCid) {
          childrenBublesWithParent.push(childId);
        }

        todo.push(childId);
      }
      done.push(processingId);
    }
    return childrenBublesWithParent;
  };

  function onDownloadProgress(progressEvent) {
    const total = progressEvent.total;
    const current = progressEvent.loaded;
    const percentCompleted = (current / total) * 100;
    const sizeCompleted = ((current / total) * selectedNode.properties?.fileSize) / 1e6;
    if (bar) bar.style.width = `${percentCompleted}%`;
    const barLabel = document.getElementById("progress-bar-label");
    if (barLabel) barLabel.textContent = `${percentCompleted.toFixed(0)}%`;
    size.textContent =
      `${sizeCompleted.toFixed(2)}MB of ` + `${(selectedNode.properties?.fileSize / 1e6).toFixed(2)}MB`;
    if (progressEvent.estimated !== undefined) {
      timertext.textContent = t('files.upload.timeRemaining');
      timer.textContent = formatTimeHHMMSS(progressEvent.estimated);
    }

    if (percentCompleted === 100) {
      if (barLabel) barLabel.textContent = `Download complete!`;
      setTimeout(() => {
        context.isProgress(false);
      }, 100);
    }
  }

  const readFileTest = async (node, isDownload) => {
    setIsDownload(isDownload);
    if (
      (node.isFile || node._type.split("/")[node._type.split("/").length - 1] === "file") &&
      node.properties?.fileStorageId !== "<link_to_file>" &&
      node.layer === "filesystem"
    ) {
      if (node.properties?.fileSize < downloadLimit) {
        if (selectedAccount !== null) {
          let logsAndVars = createEmptyLogsAndVars("GraphUserComponent:readFileTest");
          recordVariable(logsAndVars, "node (param)", node);
          try {
            setIsNodeSelect(true);
            setNodeDatas(node);

            const result = await readFileCached(
              selectedWallet?.provider,
              storageProps,
              node.properties?.fileStorageId,
              node.properties?.fileSize,
            );

            recordVariable(logsAndVars, "readFile result", result);
            setBlobFile(result);
            if (result) {
              setIsDownloadButton(true);
            }
            const imageUrl = URL.createObjectURL(result);
            setFile(imageUrl);
            if (isDownload) {
              downloadZip(result, node.properties?.fileName);
            }
          } catch (error) {
            if (error instanceof ReportingError) {
              logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
            }
            dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
          }
        } else {
          setStatus("selectedAccount is null");
        }
      } else {
        context.isProgress(true);
      }
    } else {
      setNodeDatas(node);
      setIsNodeSelect(true);
      setFile();
      setBlobFile();
    }
  };

  const readFileTest2 = async () => {
    const node = selectedNode;
    if (node !== undefined) {
      if (
        (node.isFile || node._type.split("/")[node._type.split("/").length - 1] === "file") &&
        node.properties?.fileStorageId !== "<link_to_file>" &&
        node.layer === "filesystem"
      ) {
        if (selectedAccount !== null) {
          let logsAndVars = createEmptyLogsAndVars("GraphUserComponent:readFileTest");
          recordVariable(logsAndVars, "node (param)", node);
          try {
            setIsNodeSelect(true);
            setNodeDatas(node);
            let mainDirectoryHandle = undefined;
            if (window.showDirectoryPicker) {
              mainDirectoryHandle = await window.showDirectoryPicker({ mode: "readwrite" });
            }
            await utilSingleFileDownload(selectedWallet, node, mainDirectoryHandle, onDownloadProgress);
          } catch (error) {
            if (error instanceof ReportingError) {
              logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
            }
            dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
          }
        } else {
          setStatus("selectedAccount is null");
        }
      } else {
        setNodeDatas(node);
        setIsNodeSelect(true);
        setFile();
        setBlobFile();
      }
    }
  };

  const readMetaDatas = async (node) => {
    if (node.metadataType !== undefined) {
      try {
        const authToken = await loadJwt();
        const result = await getMetadataJwt(selectedWallet?.provider, authToken, node.storagePath);
        setMetaData(result);
      } catch (error) {
        console.log(error);
      }
    } else {
      setTimeLineItems();
    }
  };

  const downloadFile = async (node) => {
    if (node && node.metadataType === undefined && node._type.split("/")[node._type.split("/").length - 1] === "file") {
      setFileName(node.properties?.fileName);
      setFileType(node.properties?.fileMimeType);
      if (node.properties?.fileStorageId !== "") {
        await readFileTest(node, true);
      }
    } else {
      setFileName();
      setFileType();
      setFile();
    }
  };

  const downloadZip = useCallback((blobFile, filename) => {
    const data = window.URL.createObjectURL(blobFile);
    const link = document.createElement("a");

    link.href = data;
    link.download = filename ? filename : "file";

    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );

    setTimeout(() => {
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  }, []);
  const removeFileTest = async (node) => {
    if (selectedAccount !== null) {
      try {
        deleteSingle2(props.processedGraph, node.id);
        const authToken = await loadJwt();
        await unProcessAndSaveProcessedGraphJwt(authToken, props.processedGraph);
        const result = JSON.stringify(await removeFile(storageProps, node.properties?.fileStorageId));
        setStatus(result);
        setFile();
        setIsDoneTicketDelete(true);
        setTimeout(() => {
          props.refreshGraph();
        }, 1500);
      } catch (error) {
        setErrortext("File removal has failed!");
        setIsErrorTicket(true);
        setIsErrorTicketRefreshGraphAfterClose(true);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };

  const removeEmptyFolder = async (node) => {
    if (selectedAccount !== null && node._type == TYPE_FOLDER2) {
      try {
        deleteSingle2(props.processedGraph, node.id);
        const authToken = await loadJwt();
        await unProcessAndSaveProcessedGraphJwt(authToken, props.processedGraph);
        setIsDoneTicketDelete(true);
        setTimeout(() => {
          props.refreshGraph();
        }, 1500);
      } catch (error) {
        console.log("GraphUserComponent:removeEmptyFolder", error);
        setErrortext("Empty folder removal has failed!");
        setIsErrorTicket(true);
        setIsErrorTicketRefreshGraphAfterClose(true);
      }
    }
  };

  const setChildClose = (nodeId) => {
    if (network) {
      var node = network.body.nodes[nodeId];
      const initialNode = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(nodeId));
      let parentNodes = network.getConnectedNodes(nodeId, "from");
    }
  };

  window.ondragstart = function () {
    return false;
  };

  function clusterByCid(id, network, value) {
    const initialNode = originalGraph.nodes.find((k) => k.id === getOnlyNumbers(id));
    if (initialNode) {
      let actuelleColor;
      if (darkColors.filter((k) => k.group === initialNode.group)[0] !== undefined) {
        actuelleColor = darkColors.filter((k) => k.group === initialNode.group.replace("b", GROUP_FULL))[0].background;
      } else {
        actuelleColor = "ffffff";
      }

      var nodeIsArray = onBubleChildren(getOnlyNumbers(id));
      nodeIsArray.push(id);

      var clusterOptionsByData = {
        joinCondition: function (childOptions) {
          return childOptions.cid == initialNode.cid && nodeIsArray.includes(getOnlyNumbers(childOptions.id));
        },
        clusterNodeProperties: {
          id: "cidCluster" + id,
          hidden: value ? true : false,
          group: initialNode.group + "diamond",
          label: initialNode.label + " (" + (nodeIsArray.length - 1).toString() + ")",
          title: (nodeIsArray.length - 1).toString() + " Subnodes",
          cid: initialNode.cid,
          size: 40,
          font: {
            color: actuelleColor,
          },
        },
      };
      network.cluster(clusterOptionsByData);
    }
  }

  function clusterBySearch(idArray) {
    if (network.isCluster("cidClusterSearch") == true) {
      network.openCluster("cidClusterSearch");
    }

    var clusterOptionsByData = {
      joinCondition: function (childOptions) {
        return !idArray.includes(childOptions.id);
      },
      clusterNodeProperties: {
        id: "cidClusterSearch",
        hidden: true,
      },
    };
    network.cluster(clusterOptionsByData);
  }

  function clusterByNode(object, network) {
    const initialNode = originalGraph.nodes.find((k) => k.id === object.parentId);
    let actuelleColor;
    if (darkColors.filter((k) => k.group === initialNode.cid + "" + initialNode.level + GROUP_FULL)[0] !== undefined) {
      actuelleColor = darkColors.filter((k) => k.group === initialNode.cid + "" + initialNode.level + GROUP_FULL)[0]
        .color;
    } else {
      actuelleColor = "ffffff";
    }
    let level = initialNode.level + 1;

    var clusterOptionsByData = {
      joinCondition: function (childOptions) {
        let childOptionsId = parseInt(childOptions.id);
        if (isNaN(childOptionsId)) {
          childOptionsId = childOptions.id;
        }
        return childOptions.cid == initialNode.cid && object.array.includes(childOptionsId);
      },
      clusterNodeProperties: {
        id: object.groupId,
        group: initialNode.cid + "" + level + GROUP_FULL + "group",
        label: object.label,
        title: object.array.length.toString(),
        cid: initialNode.cid,
        size: 40,
        font: {
          color: actuelleColor,
        },
      },
    };
    network.cluster(clusterOptionsByData);
  }

  function clusterByFilter(network) {
    var clusterOptionsByData = {
      joinCondition: function (childOptions) {
        let array = network.getNodesInCluster(childOptions.id);
        for (let nodeId of array) {
          if (network.body.nodes["cidCluster" + nodeId] && network.isCluster("cidCluster" + nodeId) === true) {
            if (network.body.nodes["cidCluster" + nodeId]) {
              var node = network.body.nodes["cidCluster" + nodeId];
              if (node) {
                node.setOptions({
                  shape: "diamond",
                });
              }
            }
          }
        }

        if (sessionStorage.getItem("dataOwnerFilter") !== null) {
          return (
            childOptions.cid !== JSON.parse(sessionStorage.getItem("dataOwnerFilter")) &&
            childOptions.cid !== JSON.parse(sessionStorage.getItem("bubleFilter"))
          );
        } else {
          return childOptions.cid !== JSON.parse(sessionStorage.getItem("bubleFilter"));
        }
      },
      clusterNodeProperties: {
        id: "cidClusterUser",
        hidden: true,
        shape: "diamond",
      },
    };
    network.cluster(clusterOptionsByData);
  }

  function clusterByHideMeta(network) {
    var clusterOptionsByData = {
      joinCondition: function (childOptions) {
        let array = network.getNodesInCluster(childOptions.id);
        if (network.isCluster("cidClusterUser") == true) {
          network.openCluster("cidClusterUser");
        }
        for (let nodeId of array) {
          if (network.body.nodes["cidCluster" + nodeId] && network.isCluster("cidCluster" + nodeId) == true) {
            if (network.body.nodes["cidCluster" + nodeId]) {
              var node = network.body.nodes["cidCluster" + nodeId];
              if (node) {
                node.setOptions({
                  shape: "diamond",
                });
              }
            }
          }
        }
        return childOptions.cid !== JSON.parse(sessionStorage.getItem("dataOwnerFilter"));
      },
      clusterNodeProperties: {
        id: "cidClusterUser",
        hidden: true,
        shape: "diamond",
      },
    };
    network.cluster(clusterOptionsByData);
  }

  function deleteNodeFromGraph() {
    sessionStorage.removeItem("isEditGraph");
    setIsVisibility3(true);
    setTimeout(() => {
      onSetActuelleGraph();
    }, 200);
    network.fit();

    setTimeout(() => {
      setIsVisibility3(false);
    }, 500);
  }

  // Calculate data completeness percentage once, used for water fill and display
  const dataCompletenessPercent = (() => {
    let total = 0;
    let count = 0;
    for (let i = 1; i <= 8; i++) {
      const catStats = twinModalParams?.categories?.[i];
      if (catStats) {
        total += (catStats.usedData / catStats.maxData) * 100;
        count++;
      }
    }
    return count > 0 ? Math.round(total / count) : 0;
  })();

  return (
    <div className="filespage-div">
      {window.innerWidth > 992 && (
        <div className="prevent-select">
          <div className="filter-div-new">
            <div className="up-div">
              <div className="categories">
                {props.isNetworkViewMode ? (
                  <div className="network-view-left-panel">
                    <div className="digital-twin-sidebar">
                      <div className="twin-3d-figure">
                        <div className="twin-figure-container">
                          <div 
                            className="water-fill-layer"
                            style={{
                              height: `${dataCompletenessPercent}%`
                            }}
                          />
                          <img 
                            className="twin-large-image" 
                            src={twin_half_body} 
                            alt="Digital Twin" 
                          />
                          <img 
                            className="twin-background-mask"
                            src={twin_background_mask} 
                            alt="" 
                          />
                        </div>
                      </div>
                      <div className="twin-data-section">
                        <div className="data-completeness-label">Data completeness</div>
                        <div className="data-completeness-value">
                          {dataCompletenessPercent}%
                        </div>
                      </div>
                      <div className="next-milestones">
                        <div className="milestone-header">Next milestones</div>
                        <div className="milestone-text">
                          To be able to offer usable and saleable data in the health sector, you need a score of <strong>67%</strong>. Your current level is <strong>{dataCompletenessPercent}%</strong>.
                        </div>
                      </div>
                    </div>
                    <CubeCategories
                      activeTab={activeTab}
                      setActiveTab={(value) => setActiveTab(value)}
                      setBubbleFilter={(value, progress) => setBubbleFilter(value, progress)}
                      setCategory={(value) => setCategory(value)}
                      isVisibility2={isVisibility2}
                      originalNodes={originalGraph.nodes}
                      handleWindowInfoSizeChange={() => handleWindowInfoSizeChange()}
                      isNetworkViewMode={true}
                    />
                  </div>
                ) : (
                  <MenuComponent
                    activeTab={activeTab}
                    setActiveTab={(value) => setActiveTab(value)}
                    setBubbleFilter={(value, progress) => setBubbleFilter(value, progress)}
                    setCategory={(value) => setCategory(value)}
                    isVisibility2={isVisibility2}
                    originalNodes={originalGraph.nodes}
                    handleWindowInfoSizeChange={() => handleWindowInfoSizeChange()}
                  />
                )}

                {!props.isNetworkViewMode && (
                <div className="show-files-div">
                  <div
                    className={
                      sessionStorage.getItem("dataOwnerFilter") !== null
                        ? "actions-div-files active"
                        : "actions-div-files"
                    }
                  >
                    <div className="checkbox-div">
                      <MDBCheckbox
                        name="checkShowFiles"
                        id="checkboxShowFiles"
                        value=""
                        aria-label="..."
                        checked={sessionStorage.getItem("dataOwnerFilter") !== null}
                        onChange={() => {
                          if (sessionStorage.getItem("dataOwnerFilter") !== null) {
                            handleWindowInfoSizeChange();
                            setShowFilesFalse();
                            sessionStorage.removeItem("hideMetaData");
                            sessionStorage.removeItem("addNewBuble");
                            sessionStorage.removeItem("isEditGraph");
                            setEditGraphOption(false);
                          } else {
                            handleWindowInfoSizeChange();
                            setShowFilesTrue();
                          }
                        }}
                      />
                      <span className="label-text">Show uploaded files</span>
                    </div>
                  </div>
                  {sessionStorage.getItem("dataOwnerFilter") !== null && (
                    <div
                      className={
                        sessionStorage.getItem("hideMetaData") !== null
                          ? "actions-div-files active"
                          : "actions-div-files"
                      }
                    >
                      <div className="checkbox-div">
                        <MDBCheckbox
                          name="checkHideMetaData"
                          id="checkboxHideMetaData"
                          value=""
                          checked={sessionStorage.getItem("hideMetaData") !== null}
                          aria-label="..."
                          onChange={() => {
                            if (sessionStorage.getItem("hideMetaData") !== null) {
                              handleWindowInfoSizeChange();
                              setHideMetaDataFalse();
                              sessionStorage.removeItem("hideMetaData");
                              sessionStorage.removeItem("addNewBuble");
                              sessionStorage.removeItem("isEditGraph");
                              setEditGraphOption(false);
                              setIsAddNewBubble(false);
                              setIsEditMode(false);
                            } else {
                              handleWindowInfoSizeChange();
                              setHideMetaDataTrue();
                              handleWindowSizeChange();
                              sessionStorage.setItem("hideMetaData", true);
                              setIsEditMode(true);
                            }
                          }}
                        />
                        <span className="label-text">Hide everything else</span>
                      </div>
                    </div>
                  )}
                </div>
                )}
              </div>
              <div className="left-div">
                {!props.isNetworkViewMode && (
                  <div className="new-human-div" onClick={() => console.log("modal open")}>
                    <img className="human-image" src={isDark ? mini_human_dark : mini_human_light} alt="human" />
                  </div>
                )}
                <div></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {window.innerWidth > 992 && props.isNetworkViewMode && (
        <div className="network-3d-model-panel" onClick={props.onSidebarModelClick}>
          <NetworkMaleModel onClick={props.onSidebarModelClick} />
        </div>
      )}

      {isVisibility2 && (
        <div
          className={
            isAddNewBubble
              ? sessionStorage.getItem("hideMetaData") !== null
                ? "graph-div active-div isaddnewbubble"
                : "graph-div isaddnewbubble"
              : sessionStorage.getItem("hideMetaData") !== null
                ? "graph-div active-div"
                : "graph-div"
          }
        >
          <div className="search-bar">
            <div className="search-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.707 12.2932L11.1685 9.75455C11.8536 8.71901 12.1297 7.46596 11.9433 6.23841C11.7568 5.01085 11.1212 3.89626 10.1596 3.11079C9.19798 2.32531 7.97894 1.92493 6.73887 1.98728C5.49881 2.04963 4.32608 2.57027 3.44812 3.44824C2.57015 4.32621 2.04951 5.49893 1.98716 6.739C1.92481 7.97906 2.32519 9.1981 3.11067 10.1597C3.89614 11.1213 5.01073 11.757 6.23828 11.9434C7.46584 12.1298 8.71889 11.8537 9.75443 11.1687L12.293 13.7072C12.4806 13.8942 12.7348 13.9992 12.9997 13.999C13.2647 13.9988 13.5187 13.8935 13.706 13.7061C13.8934 13.5188 13.9987 13.2648 13.9989 12.9999C13.9991 12.7349 13.8941 12.4808 13.707 12.2932ZM3.00003 7.00015C3.00003 6.20903 3.23463 5.43567 3.67415 4.77787C4.11368 4.12008 4.73839 3.60739 5.4693 3.30463C6.2002 3.00188 7.00447 2.92267 7.78039 3.07701C8.55632 3.23135 9.26905 3.61232 9.82846 4.17173C10.3879 4.73114 10.7688 5.44387 10.9232 6.21979C11.0775 6.99572 10.9983 7.79998 10.6955 8.53089C10.3928 9.26179 9.88011 9.88651 9.22231 10.326C8.56451 10.7656 7.79116 11.0002 7.00003 11.0002C5.93953 10.999 4.92282 10.5771 4.17293 9.82725C3.42305 9.07737 3.00123 8.06065 3.00003 7.00015Z"
                  fill="#ffffff"
                />
              </svg>
            </div>
            {searchTerm !== "" && (
              <button className="button subtle medium searchbutton" onClick={() => clearSearch()}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="#ffffff"
                  />
                </svg>
              </button>
            )}

            <input
              type="text"
              className="input-text"
              placeholder={t('files.explorer.searchPlaceholder')}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          {isInfoTickets && (
            <div className="info-tickets-div">
              <InfoComponent text1={infoText} isAddNew={true} />
            </div>
          )}

          <div className={isTransition ? "graph-canvas-container transition" : "graph-canvas-container"}>
            <div ref={containerRef} style={{ height: "100%" }} id="myCanvas" />

            {contextMenu.visible && (
              <ContextMenuComponent
                processedGraph={props.processedGraph}
                selectedNode={selectedNode}
                setBubleChildrenVisibilityTrue={(id, value) => setBubleChildrenVisibilityTrue(id, value)}
                setBubleChildrenVisibilityHidden={(id) => setBubleChildrenVisibilityHidden(id)}
                setSelectedPath={(node) => setSelectedPath(node)}
                setIsWarningTicketDelete={(value) => setIsWarningTicketDelete(value)}
                contextMenu={contextMenu}
                handleWindowSizeChange={handleWindowSizeChange}
                setChildClose={(nodeId) => setChildClose(nodeId)}
                downloadZip={(path, filename) => downloadZip(path, filename)}
                fileName={fileName}
                fileType={fileType}
                blobFile={blobFile}
                network={network}
                refreshGraph={props.refreshGraph}
                setIsUserFolder={(value) => setIsUserFolder(value)}
                downloadFile={(node) => downloadFile(node)}
              />
            )}
            {contextMenuInfo.visible && (
              <ContextInfoComponent
                selectedNode={selectedNode}
                isVisibility2={isVisibility2}
                isVisibility={isVisibility}
                setIsVisibility={() => setIsVisibility(!isVisibility)}
                setIsVisibility2={() => setIsVisibility2(!isVisibility2)}
                setIsVisibilityDiv={() => setIsVisibilityDiv(!isVisibilityDiv)}
                isNodeSelect={isNodeSelect}
                nodesCount={actuelleGraph.nodes.length}
                edgesCount={actuelleGraph.edges.length}
                nodes={actuelleGraph.nodes}
                network={network}
                setIsSendingInProgress={setIsSendingInProgress}
                setIsSentTo={setIsSentTo}
                file={file}
                blobFile={blobFile}
                fileName={fileName}
                fileType={fileType}
                setIsWarningTicket={setIsWarningTicket}
                isDownloadButton={isDownloadButton}
                downloadZip={(path, filename) => downloadZip(path, filename)}
                processedGraph={props.processedGraph}
                isGraphSite={true}
                contextMenu={contextMenuInfo}
                handleWindowInfoSizeChange={handleWindowInfoSizeChange}
                readMetaDatas={(node) => readMetaDatas(node)}
                metaData={metaData}
                downloadFile={(node) => downloadFile(node)}
              />
            )}
          </div>
          <div className="graph-edit-button-div">
            <button
              className="button outline medium"
              onClick={() => {
                handleWindowInfoSizeChange();
                setExpandAllGraph(false);
                handleWindowSizeChange();
              }}
              disabled={sessionStorage.getItem("isEditGraph") !== null}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75ZM7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M17.4519 2.88638C17.4044 2.77234 17.3244 2.67485 17.2218 2.60612C17.1191 2.53738 16.9985 2.50047 16.875 2.5H14.375C14.2092 2.5 14.0503 2.56585 13.9331 2.68306C13.8158 2.80027 13.75 2.95924 13.75 3.125C13.75 3.29076 13.8158 3.44973 13.9331 3.56694C14.0503 3.68415 14.2092 3.75 14.375 3.75H15.3663L12.6831 6.43312C12.6251 6.49115 12.579 6.56004 12.5476 6.63586C12.5162 6.71168 12.5001 6.79294 12.5001 6.875C12.5001 6.95706 12.5162 7.03832 12.5476 7.11414C12.579 7.18996 12.6251 7.25885 12.6831 7.31688C12.7411 7.3749 12.81 7.42093 12.8858 7.45234C12.9617 7.48374 13.0429 7.49991 13.125 7.49991C13.207 7.49991 13.2883 7.48374 13.3641 7.45234C13.4399 7.42093 13.5088 7.3749 13.5669 7.31688L16.25 4.63375V5.625C16.25 5.79076 16.3159 5.94973 16.4331 6.06694C16.5503 6.18415 16.7092 6.25 16.875 6.25C17.0408 6.25 17.1997 6.18415 17.3169 6.06694C17.4342 5.94973 17.5 5.79076 17.5 5.625V3.125C17.4998 3.04307 17.4834 2.96198 17.4519 2.88638Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M2.5481 2.88638C2.59555 2.77233 2.6756 2.67484 2.77823 2.6061C2.88085 2.53737 3.00148 2.50046 3.125 2.5H5.625C5.79076 2.5 5.94973 2.56585 6.06694 2.68306C6.18415 2.80027 6.25 2.95924 6.25 3.125C6.25 3.29076 6.18415 3.44973 6.06694 3.56694C5.94973 3.68415 5.79076 3.75 5.625 3.75H4.63375L7.31685 6.43312C7.43404 6.55032 7.49988 6.70926 7.49988 6.875C7.49988 7.04074 7.43404 7.19968 7.31685 7.31688C7.19966 7.43407 7.04071 7.49991 6.87497 7.49991C6.70924 7.49991 6.55029 7.43407 6.4331 7.31688L3.75 4.63375V5.625C3.75 5.79076 3.68415 5.94973 3.56694 6.06694C3.44973 6.18415 3.29076 6.25 3.125 6.25C2.95924 6.25 2.80027 6.18415 2.68306 6.06694C2.56585 5.94973 2.5 5.79076 2.5 5.625V3.125C2.5002 3.04307 2.51654 2.96198 2.5481 2.88638Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M17.4518 17.1136C17.4044 17.2277 17.3244 17.3251 17.2217 17.3939C17.1191 17.4626 16.9985 17.4995 16.875 17.5H14.375C14.2092 17.5 14.0503 17.4341 13.9331 17.3169C13.8158 17.1997 13.75 17.0408 13.75 16.875C13.75 16.7092 13.8158 16.5503 13.9331 16.4331C14.0503 16.3158 14.2092 16.25 14.375 16.25H15.3662L12.6831 13.5669C12.5683 13.4492 12.5046 13.291 12.5056 13.1266C12.5066 12.9622 12.5724 12.8049 12.6886 12.6886C12.8048 12.5724 12.9622 12.5066 13.1266 12.5055C13.291 12.5045 13.4491 12.5682 13.5668 12.683L16.25 15.3661V14.375C16.25 14.2092 16.3158 14.0503 16.4331 13.9331C16.5503 13.8158 16.7092 13.75 16.875 13.75C17.0408 13.75 17.1997 13.8158 17.3169 13.9331C17.4341 14.0503 17.5 14.2092 17.5 14.375V16.875C17.4998 16.9569 17.4834 17.038 17.4518 17.1136Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M2.5481 17.1136C2.59555 17.2277 2.6756 17.3252 2.77823 17.3939C2.88085 17.4626 3.00148 17.4995 3.125 17.5H5.625C5.79076 17.5 5.94973 17.4341 6.06694 17.3169C6.18415 17.1997 6.25 17.0408 6.25 16.875C6.25 16.7092 6.18415 16.5503 6.06694 16.4331C5.94973 16.3158 5.79076 16.25 5.625 16.25H4.63375L7.31685 13.5669C7.43162 13.4492 7.49539 13.291 7.49436 13.1266C7.49333 12.9622 7.42758 12.8049 7.31135 12.6886C7.19511 12.5724 7.03776 12.5066 6.87338 12.5055C6.70899 12.5045 6.55081 12.5682 6.4331 12.683L3.75 15.3661V14.375C3.75 14.2092 3.68415 14.0503 3.56694 13.9331C3.44973 13.8158 3.29076 13.75 3.125 13.75C2.95924 13.75 2.80027 13.8158 2.68306 13.9331C2.56585 14.0503 2.5 14.2092 2.5 14.375V16.875C2.50021 16.9569 2.51655 17.038 2.5481 17.1136Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
              </svg>
              <span className="text">Expand all</span>
            </button>

            <button
              className="button outline medium"
              onClick={() => {
                handleWindowInfoSizeChange();
                setExpandAllGraph(true);
                handleWindowSizeChange();
              }}
              disabled={sessionStorage.getItem("isEditGraph") !== null}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.99992 8.75C9.30957 8.75 8.74992 9.30964 8.74992 10C8.74992 10.6904 9.30957 11.25 9.99992 11.25C10.6903 11.25 11.2499 10.6904 11.2499 10C11.2499 9.30964 10.6903 8.75 9.99992 8.75ZM7.49992 10C7.49992 8.61929 8.61921 7.5 9.99992 7.5C11.3806 7.5 12.4999 8.61929 12.4999 10C12.4999 11.3807 11.3806 12.5 9.99992 12.5C8.61921 12.5 7.49992 11.3807 7.49992 10Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M6.20186 14.1364C6.15442 14.0223 6.07437 13.9248 5.97175 13.8561C5.86914 13.7874 5.74851 13.7505 5.62501 13.75H3.125C2.95924 13.75 2.80027 13.8158 2.68306 13.9331C2.56585 14.0503 2.5 14.2092 2.5 14.375C2.5 14.5408 2.56585 14.6997 2.68306 14.8169C2.80027 14.9342 2.95924 15 3.125 15H4.11626L2.68311 16.4331C2.62508 16.4912 2.57905 16.56 2.54764 16.6359C2.51624 16.7117 2.50008 16.7929 2.50008 16.875C2.50008 16.9571 2.51624 17.0383 2.54764 17.1141C2.57905 17.19 2.62508 17.2588 2.68311 17.3169C2.74114 17.3749 2.81002 17.4209 2.88584 17.4523C2.96166 17.4837 3.04292 17.4999 3.12498 17.4999C3.20705 17.4999 3.28831 17.4837 3.36412 17.4523C3.43994 17.4209 3.50883 17.3749 3.56686 17.3169L5.00001 15.8837V16.875C5.00001 17.0408 5.06585 17.1997 5.18306 17.3169C5.30028 17.4342 5.45925 17.5 5.62501 17.5C5.79077 17.5 5.94974 17.4342 6.06695 17.3169C6.18416 17.1997 6.25001 17.0408 6.25001 16.875V14.375C6.24979 14.2931 6.23343 14.212 6.20186 14.1364Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M13.798 14.1364C13.8455 14.0223 13.9255 13.9248 14.0281 13.8561C14.1308 13.7874 14.2514 13.7505 14.3749 13.75H16.8749C17.0407 13.75 17.1997 13.8158 17.3169 13.9331C17.4341 14.0503 17.4999 14.2092 17.4999 14.375C17.4999 14.5408 17.4341 14.6997 17.3169 14.8169C17.1997 14.9342 17.0407 15 16.8749 15H15.8837L17.3168 16.4331C17.434 16.5503 17.4998 16.7093 17.4998 16.875C17.4998 17.0407 17.434 17.1997 17.3168 17.3169C17.1996 17.4341 17.0406 17.4999 16.8749 17.4999C16.7092 17.4999 16.5502 17.4341 16.433 17.3169L14.9999 15.8837V16.875C14.9999 17.0408 14.9341 17.1997 14.8169 17.3169C14.6997 17.4342 14.5407 17.5 14.3749 17.5C14.2092 17.5 14.0502 17.4342 13.933 17.3169C13.8158 17.1997 13.7499 17.0408 13.7499 16.875V14.375C13.7501 14.2931 13.7665 14.212 13.798 14.1364Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M6.20177 5.86362C6.15433 5.97765 6.07428 6.07514 5.97166 6.14388C5.86905 6.21261 5.74843 6.24952 5.62492 6.24999H3.12492C2.95916 6.24999 2.80019 6.18415 2.68298 6.06694C2.56577 5.94973 2.49992 5.79075 2.49992 5.62499C2.49992 5.45923 2.56577 5.30026 2.68298 5.18305C2.80019 5.06584 2.95916 4.99999 3.12492 4.99999H4.11617L2.68302 3.56687C2.56825 3.44917 2.50448 3.291 2.50551 3.12662C2.50654 2.96223 2.57229 2.80487 2.68852 2.68862C2.80475 2.57237 2.9621 2.5066 3.12649 2.50554C3.29087 2.50449 3.44905 2.56824 3.56677 2.68299L4.99992 4.11612V3.125C4.99992 2.95924 5.06577 2.80027 5.18298 2.68306C5.30019 2.56585 5.45916 2.5 5.62492 2.5C5.79068 2.5 5.94965 2.56585 6.06686 2.68306C6.18407 2.80027 6.24992 2.95924 6.24992 3.125V5.62499C6.24969 5.70693 6.23333 5.78801 6.20177 5.86362Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
                <path
                  d="M13.798 5.86362C13.8455 5.97766 13.9255 6.07516 14.0281 6.14389C14.1308 6.21263 14.2514 6.24953 14.3749 6.24999H16.8749C17.0407 6.24999 17.1997 6.18415 17.3169 6.06694C17.4341 5.94973 17.4999 5.79075 17.4999 5.62499C17.4999 5.45923 17.4341 5.30026 17.3169 5.18305C17.1997 5.06584 17.0407 4.99999 16.8749 4.99999H15.8837L17.3168 3.56687C17.4315 3.44917 17.4953 3.291 17.4943 3.12662C17.4933 2.96223 17.4275 2.80487 17.3113 2.68862C17.195 2.57237 17.0377 2.5066 16.8733 2.50554C16.7089 2.50449 16.5507 2.56824 16.433 2.68299L14.9999 4.11612V3.125C14.9999 2.95924 14.9341 2.80027 14.8169 2.68306C14.6997 2.56585 14.5407 2.5 14.3749 2.5C14.2092 2.5 14.0502 2.56585 13.933 2.68306C13.8158 2.80027 13.7499 2.95924 13.7499 3.125V5.62499C13.7501 5.70692 13.7665 5.78801 13.798 5.86362Z"
                  fill={sessionStorage.getItem("isEditGraph") !== null ? "var(--text-accent-tertiary-hover" : "#ffffff"}
                />
              </svg>
              <span className="text">Close all</span>
            </button>

            {sessionStorage.getItem("hideMetaData") !== null && isEditMode && (
              <MDBTooltip
                wrapperClass="tooltip-button-edit-cancel"
                tag="div"
                title="Just as in Explorer view, you can also add folders and edit existing ones here."
              >
                <button
                  className="button outline medium"
                  onClick={() => {
                    sessionStorage.setItem("isEditGraph", true);
                    sessionStorage.setItem("addNewBuble", true);
                    setExpandAllGraph(false);
                    setEditGraphOption(true);
                    setEditGraphOption(true);
                    setIsEditMode(false);
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.75 2.5C2.36929 2.5 1.25 3.61929 1.25 5C1.25 6.38071 2.36929 7.5 3.75 7.5C5.13071 7.5 6.25 6.38071 6.25 5C6.25 3.61929 5.13071 2.5 3.75 2.5ZM0 5C0 2.92893 1.67893 1.25 3.75 1.25C5.82107 1.25 7.5 2.92893 7.5 5C7.5 6.46977 6.65444 7.74205 5.42323 8.35693L6.6902 12.5054C6.75135 12.5018 6.81296 12.5 6.875 12.5C8.41045 12.5 9.68726 13.6074 9.95034 15.0671L13.8481 15.5543C14.1494 14.5121 15.1107 13.75 16.25 13.75C17.6307 13.75 18.75 14.8693 18.75 16.25C18.75 17.6307 17.6307 18.75 16.25 18.75C15.0617 18.75 14.067 17.9209 13.8129 16.8096L9.92171 16.3232C9.60454 17.713 8.36087 18.75 6.875 18.75C5.14911 18.75 3.75 17.3509 3.75 15.625C3.75 14.3999 4.45502 13.3394 5.48148 12.8271L4.2271 8.71994C4.07086 8.73978 3.91163 8.75 3.75 8.75C1.67893 8.75 0 7.07107 0 5ZM6.875 13.75C5.83947 13.75 5 14.5895 5 15.625C5 16.6605 5.83947 17.5 6.875 17.5C7.91053 17.5 8.75 16.6605 8.75 15.625C8.75 14.5895 7.91053 13.75 6.875 13.75ZM16.25 15C15.5596 15 15 15.5596 15 16.25C15 16.9404 15.5596 17.5 16.25 17.5C16.9404 17.5 17.5 16.9404 17.5 16.25C17.5 15.5596 16.9404 15 16.25 15Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M17.8347 6.73104L17.5729 6.0575C17.543 5.98068 17.5104 5.90331 17.4756 5.82564L17.1694 5.14495L17.6232 4.55253C17.6977 4.45548 17.7845 4.34414 17.8836 4.21851C17.9734 4.10514 18.0447 4.01389 18.1015 3.94049C17.9495 3.77081 17.6996 3.51249 17.2889 3.12521L16.0537 4.05593L15.3864 3.7675C15.3314 3.74369 15.2746 3.72035 15.217 3.69838L14.5361 3.43875L14.2984 1.875H13.1781C13.1455 2.06024 13.1061 2.32032 13.0597 2.68959L12.9669 3.4269L12.2751 3.69774C12.2202 3.71917 12.1661 3.74184 12.1124 3.76588L11.4286 4.07096L10.192 3.11229C10.1218 3.17416 10.031 3.25854 9.91486 3.37321C9.66736 3.61689 9.49586 3.79755 9.37686 3.93084C9.5665 4.16553 9.73449 4.3812 9.87911 4.57575L10.3206 5.1694L10.0125 5.84206C9.98461 5.90325 9.95824 5.96435 9.93425 6.02581L9.67111 6.69903L8.125 6.93223V8.03154L9.66513 8.25883L9.92549 8.94455C9.95388 9.01962 9.98538 9.09504 10.02 9.1708L10.333 9.85671L9.87211 10.4536C9.79825 10.5492 9.71313 10.6587 9.61574 10.7821C9.52486 10.8971 9.45262 10.9893 9.39561 11.0632C9.54861 11.2335 9.80238 11.4937 10.2157 11.8758L11.444 10.9436L12.1136 11.2325C12.1696 11.2566 12.2267 11.2799 12.2849 11.3023L12.9639 11.5625L13.2016 13.125H14.3219C14.3545 12.9396 14.3939 12.6796 14.4402 12.3103L14.5326 11.5755L15.2215 11.3035C15.2777 11.2813 15.3338 11.2581 15.3891 11.2335L16.0752 10.9292L17.3041 11.8913C17.3741 11.8298 17.4652 11.7455 17.5821 11.6302C17.8345 11.3815 18.008 11.1982 18.1271 11.0642C17.9271 10.8156 17.7585 10.5994 17.6211 10.4157L17.1817 9.82809L17.4806 9.15799C17.5076 9.09756 17.5344 9.03411 17.561 8.96762L17.8262 8.30166L19.375 8.06697V6.96662L17.8347 6.73104ZM15.5179 9.26757C15.2857 9.49975 15.0102 9.68393 14.7069 9.8096C14.4036 9.93527 14.0785 9.99997 13.7502 10C13.4219 10 13.0968 9.93539 12.7935 9.80977C12.4901 9.68416 12.2145 9.50002 11.9824 9.26789C11.7502 9.03577 11.566 8.76019 11.4404 8.45689C11.3147 8.15359 11.25 7.82851 11.25 7.50021C11.25 7.17191 11.3146 6.84682 11.4402 6.5435C11.5659 6.24018 11.75 5.96458 11.9821 5.73242C12.4509 5.26354 13.0868 5.00009 13.7498 5.00001C14.4128 4.99994 15.0487 5.26326 15.5176 5.73204C15.7498 5.96416 15.934 6.23975 16.0596 6.54305C16.1853 6.84636 16.25 7.17145 16.25 7.49975C16.25 7.82806 16.1854 8.15316 16.0598 8.45648C15.9341 8.75981 15.75 9.03542 15.5179 9.26757ZM13.75 8.75C13.9972 8.75 14.2389 8.67669 14.4445 8.53934C14.65 8.40199 14.8102 8.20676 14.9048 7.97835C14.9995 7.74995 15.0242 7.49861 14.976 7.25614C14.9278 7.01366 14.8087 6.79093 14.6339 6.61612C14.4591 6.4413 14.2363 6.32225 13.9939 6.27402C13.7514 6.22579 13.5001 6.25054 13.2716 6.34515C13.0432 6.43976 12.848 6.59998 12.7107 6.80554C12.5733 7.0111 12.5 7.25277 12.5 7.5C12.5 7.83152 12.6317 8.14946 12.8661 8.38388C13.1005 8.6183 13.4185 8.75 13.75 8.75Z"
                      fill="#ffffff"
                    />
                  </svg>
                  <span className="text">Edit mode</span>
                </button>
              </MDBTooltip>
            )}
            {isAddNewBubble && (
              <div className="tooltip-button-cancel">
                <button
                  className="button outline medium"
                  onClick={() => {
                    deleteNodeFromGraph();
                  }}
                >
                  <span className="text">Cancel</span>
                </button>
              </div>
            )}
            {!isAddNewBubble && sessionStorage.getItem("hideMetaData") !== null && !isEditMode && (
              <div className="tooltip-button-cancel">
                <button
                  className="button outline medium"
                  onClick={() => {
                    sessionStorage.removeItem("addNewBuble");
                    sessionStorage.removeItem("isEditGraph");
                    setEditGraphOption(false);
                    setIsAddNewBubble(false);
                    setIsEditMode(true);
                  }}
                  style={{ minWidth: "150px" }}
                >
                  <span className="text">Close edit mode</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {!props.isNetworkViewMode && (
        <InfoView
          setIsVisibilityDiv={() => setIsVisibilityDiv(!isVisibilityDiv)}
          isDownloadButton={isDownloadButton}
          downloadZip={(path) => downloadZip(path)}
          processedGraph={props.processedGraph}
          isGraphSite={true}
          refreshGraph={props.refreshGraph}
        />
      )}

      <div className="ticket-div">
        {isSendingInProgress && (
          <>
            <InformationsTicket close={() => setIsSendingInProgress(false)} text={"Sending feedback in progress…"} />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isSentTo && (
          <>
            <NotificationsTicket
              close={() => {
                setIsSentTo(false);
                context.onSetIsRender();
              }}
              text={"Thank you for your feedback!"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isWarningTicket && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicket(false);
              }}
              text={"You have reached the maximum number of characters!"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isDoneTicketDelete && (
          <>
            <NotificationsTicket
              close={() => {
                setIsDoneTicketDelete(false);
                context.onSetIsRender();
              }}
              text={"Deleted sucessfully!"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
        {isWarningTicketDelete && (
          <>
            <WarningTicket
              close={() => {
                setIsWarningTicketDelete(false);
              }}
              text={
                !isUserFolder
                  ? "Are you sure that you want to delete the File?"
                  : "Are you sure that you want to delete the Folder?"
              }
              actionsButton={true}
              onDelete={() => {
                if (!isUserFolder) {
                  removeFileTest(selectedPath);
                } else {
                  removeEmptyFolder(selectedPath);
                }
                setIsWarningTicketDelete(false);
              }}
              buttonText={"Delete"}
            />
            <div style={{ height: "20px" }} />
          </>
        )}

        {isErrorTicket && (
          <>
            <ErrorTicket
              close={() => {
                setIsErrorTicket(false);
                if (isErrorTicketRefreshGraphAfterClose) {
                  props.refreshGraph();
                  setIsErrorTicketRefreshGraphAfterClose(false);
                }
              }}
              text={errortext}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>
      {context.getState()?.modalName === "createfolder" && (
        <CreateFolderNameModal
          visible={context.getState()?.modalOpened}
          modalText={context.getState()?.modalText}
          modalParam={context.getState()?.modalParam}
        />
      )}
      {isVisibility3 && <DwinityLoader />}
    </div>
  );
}
